
import Vue from 'vue'
import * as $api from '../api/index'









export default function wxShare ({shareTitle, shareDes, timelineTitle, link, imgUrl} = {}) {
let data = {
realUrl: link || window.location.href

}
$api.purePost('WX_TICKIT', data, (res) => {
if (res.data) {
window.wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature: res.data.signature,
jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone']
})
}
})

window.wx.ready(() => {

window.wx.onMenuShareAppMessage({
title: shareTitle, // 分享标题
desc: shareDes || 'Bloom，发现有趣的活动有趣的人', // 分享描述
link: link || window.location.href, // 分享链接
imgUrl: imgUrl || 'https://img.webloom.cn/img/logo/png/bloom-logo.png' 
})

window.wx.onMenuShareTimeline({
title: timelineTitle || shareDes || 'Bloom，发现有趣的活动有趣的人', // 分享标题，由于分享到朋友圈没有desc，所以这里采用的策略是，指定的朋友圈分享标题优先，其次采用发送给朋友的描述，最后采用默认文案。
link: link || window.location.href, // 分享链接
imgUrl: imgUrl || 'https://img.webloom.cn/img/logo/png/bloom-logo.png' 
})

window.wx.onMenuShareQQ({
title: shareTitle, // 分享标题
desc: shareDes || 'Bloom，发现有趣的活动有趣的人', // 分享描述
link: link || window.location.href, // 分享链接
imgUrl: imgUrl || 'https://img.webloom.cn/img/logo/png/bloom-logo.png' 
})

window.wx.onMenuShareQZone({
title: shareTitle, // 分享标题
desc: shareDes || 'Bloom，发现有趣的活动有趣的人', // 分享描述
link: link || window.location.href, // 分享链接
imgUrl: imgUrl || 'https://img.webloom.cn/img/logo/png/bloom-logo.png' 
})
})
window.wx.error((res) => {
})
}

Vue.prototype.$wxShare = wxShare



// WEBPACK FOOTER //
// ./src/assets/js/weChat.js